import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58b8e191&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8e191",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b8e191')) {
      api.createRecord('58b8e191', component.options)
    } else {
      api.reload('58b8e191', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58b8e191&scoped=true", function () {
      api.rerender('58b8e191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-fans-msg/index.vue"
export default component.exports